import { createRoot } from 'react-dom/client';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
// project imports
import App from 'App';
import { BASE_PATH } from 'config';
import { store } from 'store';
import * as serviceWorker from 'serviceWorker';
import reportWebVitals from 'reportWebVitals';
import { TravelPlansProvider } from 'hooks/api/travel-plan/context';
import { TravelRequestProvider } from 'hooks/api/travel-request/context';
import { BranchCodeProvider } from 'hooks/api/terminology/branch-code/context';
import { BudgetLineProvider } from 'hooks/api/terminology/budget-line/context';
import { DepartmentProvider } from 'hooks/api/terminology/department/context';
import { BankProvider } from 'hooks/api/terminology/bank/context';
import { JobTitleProvider } from 'hooks/api/terminology/job-title/context';
import { SiteProvider } from 'hooks/api/terminology/site/context';
import { DistrictProvider } from 'hooks/api/terminology/district/context';
import { OrganizationProvider } from 'hooks/api/terminology/organization/context';
import { ProjectCodeProvider } from 'hooks/api/terminology/project-code/context';
import { ProvinceProvider } from 'hooks/api/terminology/province/context';
import { UsersProvider } from 'hooks/api/users/context';
import { RoleProvider } from 'hooks/api/roles/context';
import { AcquittalsProvider } from 'hooks/api/travel-acquital/context';
import { NotificationsProvider } from 'hooks/api/notifications/context';
import { DocumentProvider } from 'hooks/api/documents/context';

// style + assets
import 'assets/scss/style.scss';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <NotificationsProvider>
            <RoleProvider>
                <UsersProvider>
                    <ProvinceProvider>
                        <DistrictProvider>
                            <ProjectCodeProvider>
                                <OrganizationProvider>
                                    <SiteProvider>
                                        <DepartmentProvider>
                                            <BudgetLineProvider>
                                                <BranchCodeProvider>
                                                    <TravelPlansProvider>
                                                        <TravelRequestProvider>
                                                            <AcquittalsProvider>
                                                                <DocumentProvider>
                                                                    <JobTitleProvider>
                                                                        <BankProvider>
                                                                            <BrowserRouter basename={BASE_PATH}>
                                                                                <App />
                                                                            </BrowserRouter>
                                                                        </BankProvider>
                                                                    </JobTitleProvider>
                                                                </DocumentProvider>
                                                            </AcquittalsProvider>
                                                        </TravelRequestProvider>
                                                    </TravelPlansProvider>
                                                </BranchCodeProvider>
                                            </BudgetLineProvider>
                                        </DepartmentProvider>
                                    </SiteProvider>
                                </OrganizationProvider>
                            </ProjectCodeProvider>
                        </DistrictProvider>
                    </ProvinceProvider>
                </UsersProvider>
            </RoleProvider>
        </NotificationsProvider>
    </Provider>
);

serviceWorker.unregister();

reportWebVitals();
